import {regionIsoEnum} from "@/core/enums/regionIsoEnum";

export function regionRelativeUrl(path, isAsset = false) {
    const regionPathConfig = getRegionPathConfig();
    const ASSETS_PATH = '/assets';
    let regionPath = isAsset ? (regionPathConfig || regionIsoEnum.GERMANY) : regionPathConfig;

    if (!regionPath || !path) {
        return path;
    }

    if (isAsset){
        if (regionPath === regionIsoEnum.GERMANY) {
            regionPath = ASSETS_PATH;
        } else {
            regionPath += ASSETS_PATH;
        }
    }

    if (path.startsWith("http") || path.startsWith("www")) {
        return path;
    }

    if (!path.startsWith("/")) {
        path = `/${path}`;
    }

    if (regionPath === ASSETS_PATH) {
        return `${regionPath}${path}`;
    }

    // Match a real path segment, not a bare string prefix: otherwise e.g.
    // regionPath "br" treats "/broadcasting/auth/" as already-prefixed (because
    // "broadcasting" starts with "br") and skips adding "/br", sending the
    // request to Germany instead of Brazil.
    if (path !== `/${regionPath}` && !path.startsWith(`/${regionPath}/`)){
        return `/${regionPath}${path}`;
    }

    return path;
}

export function pathWithoutRegion(path) {
    if (isGermanyRegion()) {
        return path;
    }

    let removeSlash = false;
    let newPath = path;

    if (!newPath.startsWith("/")) {
        newPath = `/${newPath}`;
        removeSlash = true;
    }

    const regionPathConfig = getRegionPathConfig();
    const regionPath = getRegionPath();

    if (newPath.startsWith(regionPath)) {
        newPath = newPath.replace(`/${regionPathConfig}`, "");
    }

    return removeSlash ? newPath.substring(1) : newPath;
}

/**
 * Countries region path
 * e.g.
 * Germany - '/'
 * Austria - '/at/'
 * Australia - '/au/'
 * Italy - '/it/'
 * United Kingdom - '/uk/'
 * Brazil - '/br/'
 */
export function getRegionPath() {
    const regionPathConfig = getRegionPathConfig();

    return isGermanyRegion(regionPathConfig) ? '/' : `/${regionPathConfig}/`;
}

export function isGermanyRegion(regionPathConfig = undefined) {
    if (!regionPathConfig) {
        regionPathConfig = getRegionPathConfig();
    }

    return regionPathConfig === '' || regionPathConfig === regionIsoEnum.GERMANY;
}

export function isItalyRegion(regionPathConfig = undefined) {
    if (!regionPathConfig) {
        regionPathConfig = getRegionPathConfig();
    }

    return regionPathConfig === regionIsoEnum.ITALY;
}

export function isBrazilRegion(regionPathConfig = undefined) {
    if (!regionPathConfig) {
        regionPathConfig = getRegionPathConfig();
    }

    return regionPathConfig === regionIsoEnum.BRAZIL;
}

export function isUnitedKingdomRegion(regionPathConfig = undefined) {
    if (!regionPathConfig) {
        regionPathConfig = getRegionPathConfig();
    }

    return regionPathConfig === regionIsoEnum.UNITED_KINGDOM;
}

export function getRegionPathConfig() {
    return process.env.MIX_REGION_PATH ?? '';
}

/**
 * Get country slug for the current region
 * Mirrors \App\Enums\Regions\RegionEnum::countrySlug()
 * @returns {string}
 */
export function getCountrySlug() {
    const regionPath = getRegionPathConfig() || 'de';

    const mapping = {
        'de': 'germany',
        'at': 'austria',
        'au': 'australia',
        'uk': 'unitedkingdom',
        'it': 'italy',
        'br': 'brazil',
    };

    return mapping[regionPath] || 'germany';
}
